import { round } from "shared-ui/utils/numbers";

export const roundFoodMacro = (value: number | null) => {
  return round(value || 0, 1);
};
